import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2cc699e2")

_pushScopeId("data-v-2cc699e2")
const _hoisted_1 = {
  key: 0,
  class: "faq-delimiter"
}
const _hoisted_2 = { class: "d-flex justify-content-between" }
const _hoisted_3 = { class: "faqTitle" }
const _hoisted_4 = {
  key: 1,
  class: "pt6"
}
const _hoisted_5 = { class: "text-r" }
const _hoisted_6 = { class: "text-length-title" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" /150 ")
const _hoisted_8 = {
  key: 2,
  class: "pt6"
}
const _hoisted_9 = { class: "faqQuestion" }
const _hoisted_10 = { class: "d-flex justify-content-between" }
const _hoisted_11 = {
  key: 0,
  class: "faqTitle"
}
const _hoisted_12 = {
  key: 3,
  class: "pt6"
}
const _hoisted_13 = { class: "text-r" }
const _hoisted_14 = { class: "text-length-title" }
const _hoisted_15 = { class: "text-length-title" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" /500 ")
const _hoisted_17 = {
  key: 4,
  class: "faqAnswer"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock(_Fragment, null, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.faqs, (item, index) => {
      return (_openBlock(), _createBlock("div", {
        class: ["faq-main-block", _ctx.editMode ? 'editMode' : 'viewMode'],
        key: index
      }, [
        (!_ctx.editMode && index != 0)
          ? (_openBlock(), _createBlock("div", _hoisted_1))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_2, [
          _createVNode("div", null, [
            _createVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('faq.question.title')) + " " + _toDisplayString(index + 1), 1),
            (_ctx.editMode && item.id)
              ? (_openBlock(), _createBlock("i", {
                  key: 0,
                  class: "icon-f icon-earth-shape fs-20 pl10",
                  onClick: ($event: any) => (_ctx.addTranslations(item.id))
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", null, [
            (_ctx.editMode)
              ? (_openBlock(), _createBlock("i", {
                  key: 0,
                  class: "icon-f icon-delete-cross fs-16",
                  onClick: ($event: any) => (_ctx.deleteFAQItem(index))
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.editMode)
          ? (_openBlock(), _createBlock("div", _hoisted_4, [
              _withDirectives(_createVNode("input", {
                required: "",
                type: "text",
                maxlength: "150",
                "onUpdate:modelValue": ($event: any) => (item.question = $event),
                class: "bookit-input product-input form-control h48"
              }, null, 8, ["onUpdate:modelValue"]), [
                [_vModelText, item.question]
              ]),
              _createVNode("div", _hoisted_5, [
                _createVNode("span", _hoisted_6, [
                  _createVNode("span", {
                    class: { 'length-limit': item.question.length > 149 }
                  }, _toDisplayString(item.question.length), 3),
                  _hoisted_7
                ])
              ])
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_8, [
              _createVNode("span", _hoisted_9, _toDisplayString(item.question), 1)
            ])),
        _createVNode("div", _hoisted_10, [
          (_ctx.editMode)
            ? (_openBlock(), _createBlock("div", _hoisted_11, _toDisplayString(_ctx.$t('faq.answer.title')), 1))
            : _createCommentVNode("", true)
        ]),
        (_ctx.editMode)
          ? (_openBlock(), _createBlock("div", _hoisted_12, [
              _withDirectives(_createVNode("textarea", {
                required: "",
                name: "textArea",
                id: "arrivalInstructions",
                class: "bookit-textarea product-textarea resize-off long-description form-control",
                maxlength: "500",
                "onUpdate:modelValue": ($event: any) => (item.answer = $event)
              }, "\n      ", 8, ["onUpdate:modelValue"]), [
                [_vModelText, item.answer]
              ]),
              _createVNode("div", _hoisted_13, [
                _createVNode("span", _hoisted_14, [
                  _createVNode("span", _hoisted_15, [
                    _createVNode("span", {
                      class: { 'length-limit': item.answer.length > 499 }
                    }, _toDisplayString(item.answer.length), 3),
                    _hoisted_16
                  ])
                ])
              ])
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_17, _toDisplayString(item.answer), 1))
      ], 2))
    }), 128)),
    (_ctx.items.length > 3 && !_ctx.editMode && !_ctx.showAll)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showAll = true)),
          class: "show-all-clear-filter align-items-lg-center m-auto"
        }, [
          _createVNode("span", null, _toDisplayString(_ctx.$t('button.showAll')), 1)
        ]))
      : _createCommentVNode("", true)
  ], 64))
})